export default __webpack_public_path__ + "static/participation-0897db20c01c52597b0dda99022f7179.webp";